module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/clock_arrow_download.f2d75cbac3c444f1e69f87afaed57f6b.svg";